module.exports = __webpack_public_path__ + "banquet/components/AppStoreBadges/images/en-play-badge.f09306911b51aaab7c3ac45eceefc30a.png";


//////////////////
// WEBPACK FOOTER
// ./banquet/components/AppStoreBadges/images/en-play-badge.png
// module id = 1651
// module chunks = 1